import axios from 'axios';

const API_URL = window.location.origin;
const TOKEN_KEY = '_loeq_t';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

// Token stored in localStorage as primary auth mechanism
// Cookies are unreliable behind k8s proxies with SameSite restrictions
let _memToken = null;

// Initialize from storage
try { _memToken = localStorage.getItem(TOKEN_KEY); } catch { /* private browsing */ }

export function setSessionToken(token) {
  _memToken = token;
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch { /* ignore */ }
}

export function clearSession() {
  _memToken = null;
  try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
}

// ALWAYS send token as Authorization header — this is the primary auth for production
api.interceptors.request.use((config) => {
  if (_memToken) {
    config.headers.Authorization = `Bearer ${_memToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      const isPublicRoute = path === '/';
      const isAuthCheck = error.config?.url?.includes('/auth/me');
      if (!isPublicRoute && !isAuthCheck) {
        clearSession();
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
